import toLowerCase from './toLowerCase';
import convertFirstLetter from './_convertFirstLetter';

const res = convertFirstLetter(toLowerCase);
export default res;
